<template>
    <va-edit-layout>
        <RentalTransactionEventFee-form
            :id="id"
            :title="title"
            :item="item"
        ></RentalTransactionEventFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
